/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type SuggestionBodyOutOfOffice_suggestionPayload = {
    readonly calendarId?: string | null | undefined;
    readonly minDate?: string | null | undefined;
    readonly maxDate?: string | null | undefined;
    readonly targetEvent?: {
        readonly title: string | null;
    } | null | undefined;
    readonly " $refType": "SuggestionBodyOutOfOffice_suggestionPayload";
};
export type SuggestionBodyOutOfOffice_suggestionPayload$data = SuggestionBodyOutOfOffice_suggestionPayload;
export type SuggestionBodyOutOfOffice_suggestionPayload$key = {
    readonly " $data"?: SuggestionBodyOutOfOffice_suggestionPayload$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"SuggestionBodyOutOfOffice_suggestionPayload">;
};



const node: ReaderFragment = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "SuggestionBodyOutOfOffice_suggestionPayload",
    "selections": [
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "calendarId",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "minDate",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "maxDate",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Event",
                    "kind": "LinkedField",
                    "name": "targetEvent",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "title",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "SuggestionResultTeammateOutOfOfficePayload",
            "abstractKey": null
        }
    ],
    "type": "SuggestionResultPayload",
    "abstractKey": "__isSuggestionResultPayload"
} as any;
(node as any).hash = '167449f07abfa1e54e14d8e8d29d9212';
export default node;
